/**
 * מיון שיחות המעקב (אפיון 5.1): "ממוינת לפי מועד, כשפולו-אפים באיחור
 * מוצגים למעלה ומסומנים".
 *
 * כלומר שתי קבוצות: קודם כל מה שכבר עבר זמנו — הישן ביותר ראשון, כי הוא
 * הכי באיחור — ואחריו העתידיים לפי סדר עולה של מועד. השרת מחזיר בסדר
 * שלו, ולכן המיון נעשה כאן.
 */
export interface SortableFollowup {
  scheduled_at: string;
}

export function sortFollowups<T extends SortableFollowup>(items: T[], now: Date = new Date()): T[] {
  const nowMs = now.getTime();
  return [...items].sort((a, b) => {
    const ta = timeOf(a.scheduled_at);
    const tb = timeOf(b.scheduled_at);
    const aLate = ta <= nowMs;
    const bLate = tb <= nowMs;
    // באיחור תמיד מעל מה שעוד לא הגיע זמנו.
    if (aLate !== bLate) return aLate ? -1 : 1;
    // בתוך כל קבוצה — לפי מועד עולה. בקבוצת האיחור זה מציף את הישן ביותר.
    return ta - tb;
  });
}

/** האם מועד הפולו-אפ כבר עבר. */
export function isOverdue(scheduledAt: string, now: Date = new Date()): boolean {
  const t = timeOf(scheduledAt);
  return Number.isFinite(t) && t <= now.getTime();
}

/**
 * מועד לא תקין (null/מחרוזת ריקה/תאריך שלא נפרס) לא נחשב באיחור, ויורד
 * לסוף הרשימה — עדיף מלהציף שורה שבורה לראש המסך.
 */
function timeOf(value: string): number {
  const t = new Date(value).getTime();
  return Number.isFinite(t) ? t : Number.POSITIVE_INFINITY;
}
